import React from 'react'

const FatReport = ({ state, onChange, onSubmit, isFinalSubmitting, setIsFinalSubmitting, history, handleAdd, handleRemove, photoState, documentState, handleFileChange }) => {
  return (

    <React.Fragment>

      <div className="row">
        <div className="col-md-12 ">
          <div className="appraisal-report-table-responsive">
            <table className="assessment-table" cellSpacing={0}>
              <tbody>

                <tr>
                  <td className="hd-s2 pd10">
                    {" "}
                    <p>Machinery</p>
                  </td>
                  <td className="hd-s2 pd10 w300" >
                    {/* <p className="text-left">Enquiry Reference</p> */}
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                    <p className="s1">Witness：</p>
                  </td>

                  <td className="tb-input-value">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Manufacture"
                      name={state.witnessManufacturer.name}
                      value={state.witnessManufacturer.value}
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                  </td>

                  <td className="tb-input-value">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Shipyard"
                      name={state.witnessShipyard.name}
                      value={state.witnessShipyard.value}
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                    {/* <p className="s1">3.</p> */}
                  </td>

                  <td className="tb-input-value">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Owner"
                      name={state.witnessOwner.name}
                      value={state.witnessOwner.value}
                      onChange={onChange}

                    />
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                    {/* <p className="s1">4</p> */}
                  </td>

                  <td className="tb-input-value">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company"
                      name={state.witnessCompany.name}
                      value={state.witnessCompany.value}
                      onChange={onChange}

                    />
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                    <p className="s1">Reported by</p>
                  </td>

                  <td className="tb-input-value">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Reported By"
                      name={state.reportedBy.name}
                      value={state.reportedBy.value}
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                    <p className="s1">Date of Inspection</p>
                  </td>

                  <td className="tb-input-value">
                    <input
                      type="date"
                      className="form-control"
                      placeholder=""
                      name={state.dateOfInspection.name}
                      value={state.dateOfInspection.value}
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                    <p className="s1">Place of Inspection.</p>
                  </td>

                  <td className="tb-input-value">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Place Of Inspection"
                      name={state.placeOfInspection.name}
                      value={state.placeOfInspection.value}
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                    <p className="s1">Result</p>
                  </td>

                  <td className="tb-input-value">
                    <select
                      className="form-control"
                      placeholder=""
                      name={state.result.name}
                      value={state.result.value}
                      onChange={onChange}
                    >
                      <option value={''}>Select</option>
                      <option value={'Accepted'}>Accepted</option>
                      <option value={'Rejected'}>Rejected</option>

                    </select>
                  </td>
                </tr>
                <tr>
                  <td className="td-s1">
                    <p className="s1">
                      Item of Inspection, Result and problem:
                    </p>
                  </td>

                  <td className="tb-input-value">
                    <textarea
                      className="form-control"
                      name={state.itemOfInspectionResultAndProblem.name}
                      value={state.itemOfInspectionResultAndProblem.value}
                      onChange={onChange}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="row">
              <div className="col-lg-12">
                <table className="mrt20">
                  <tbody>
                    <tr>
                      <td className="hd-b">
                        <p>Comment</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="input-textarea">
                        <textarea
                          placeholder='Enter Comment'
                          name={state.comment.name}
                          value={state.comment.value}
                          onChange={onChange} />
                      </td>
                    </tr>
                    <tr>
                      <td className="hd-b">
                        <p>Feedback  to next vessel and/or another shipyard vessel：</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="input-textarea">
                        <textarea
                          placeholder='Enter Feedback'
                          name={state.feedback.name}
                          value={state.feedback.value}
                          onChange={onChange} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="row">
            {/* Photos Table */}
            <div className="col-lg-6">
              <div className="appraisal-report-table-responsive">
                <table className="assessment-table" cellSpacing={0}>
                  <tbody>
                    <tr>
                      <td className="td-s1 td-s1-heading" colSpan={3}>
                        <p className="s1 text-left">Photos:</p>
                      </td>
                    </tr>
                    {/* Photos Table */}
                    {photoState.map((p, i) => (
                      <tr key={i}>
                        <td className="tb-input-value pl10 300">
                          <p className="text-left">{i + 1})</p>
                        </td>
                        <td className="tb-input-value">
                          {p.new ? (
                            <input
                              type="file"
                              className="form-control"
                              onChange={(e) => handleFileChange(e, i, "photo")}
                            />
                          ) : (
                            <span>{p.file}</span>
                          )}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleRemove(i, "photo")}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td colSpan={3}>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          style={{
                            backgroundImage:
                              "linear-gradient(90deg, rgb(105, 150, 181), rgb(43, 90, 126))",
                            borderColor: "rgb(43, 90, 126)"
                          }}
                          onClick={() => handleAdd("photo")}
                        >
                          ➕ Add Photo
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Documents Table */}
            <div className="col-lg-6">
              <div className="appraisal-report-table-responsive">
                <table className="assessment-table" cellSpacing={0}>
                  <tbody>
                    <tr>
                      <td className="td-s1 td-s1-heading" colSpan={3}>
                        <p className="s1 text-left">Attached Documents</p>
                      </td>
                    </tr>
                    {/* Documents Table */}
                    {documentState.map((d, i) => (
                      <tr key={i}>
                        <td className="tb-input-value pl10 300">
                          <p className="text-left">{i + 1})</p>
                        </td>
                        <td className="tb-input-value">
                          {d.new ? (
                            <input
                              type="file"
                              className="form-control"
                              onChange={(e) => handleFileChange(e, i, "document")}
                            />
                          ) : (
                            <span>{d.file}</span>
                          )}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleRemove(i, "document")}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td colSpan={3}>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm mt-2"
                          onClick={() => handleAdd("document")}
                          style={{
                            backgroundImage:
                              "linear-gradient(90deg, rgb(105, 150, 181), rgb(43, 90, 126))",
                            borderColor: "rgb(43, 90, 126)"
                          }}
                        >
                          ➕ Add Document
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="final-checkbox">
            <div class="form-check">
              <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
              <label class="form-check-label" for="productdiscountCheck1">Send to Office for Review</label>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-12 text-left ">
              <button

                className="btn btn-success"
                style={{
                  backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                  borderColor: "#2b5a7e"
                }}
                onClick={() => {
                  onSubmit()
                }}
              >
                Submit
              </button>
              <button
                type="reset"
                className="btn btn-danger ms-3"
                style={{
                  backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                  borderColor: "#2b5a7e"
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>

  )
}

export default FatReport